import React from 'react';

import { Routes } from 'react-router-dom';

import { SentryRoute as Route } from '@vk-hr-tek/core/monitoring/SentryRoute';

import { PageError } from '../../../layout';
import { PageRedirect } from '../../ui/page';
import { AuthById } from '../AuthById';

import { Login } from './Login';
import { VerifyAuthCode } from './VerifyAuthCode';
import { Register } from './Register';

export const VKAuth = (): JSX.Element => {
  return (
    <Routes>
      <Route path="login" element={<Login />} />
      <Route path="register" element={<Register />} />
      <Route path="result" element={<VerifyAuthCode />} />
      <Route path="invite" element={<PageRedirect to="login" />} />
      <Route path=":id/*" element={<AuthById />} />
      <Route
        path="*"
        element={
          <div>
            <PageError status={404} />
          </div>
        }
      />
    </Routes>
  );
};
